module.exports = "/static/assets/7541a408ec69080501071d6f06d6bcce.png";